/*
 * Zerene staff analytics -> Google tag bridge
 *
 * Runs after zerene-analytics-mode.js and before GTM/Google tags load.
 * It publishes the current Zerene analytics mode into Google's tag state so
 * Shopify's native Google & YouTube ecommerce events can use the same staff
 * classification as storefront GTM events.
 *
 * Mapping:
 *   none     -> traffic_type=external; debug_mode omitted
 *   internal -> traffic_type=internal; debug_mode omitted
 *   debug    -> traffic_type=external; GA4 config debug_mode=true
 *
 * traffic_type is safe to maintain with the global `set` command. GA4 Debug
 * mode is different: it must be enabled on the GA4 config/event command, not
 * merely placed on a global `set`. Also, once Debug has been enabled in an
 * already-loaded page, omitting debug_mode does not reliably undo that page's
 * Google tag context. Therefore leaving Debug triggers one reload; the fresh
 * page then initializes cleanly from the cookie-backed Internal/None state.
 */

(() => {
  const analyticsMode = window.ZereneAnalyticsMode;
  if (!analyticsMode) return;

  const GA4_MEASUREMENT_ID = 'G-VJZE2PVK6B';

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function () {
      window.dataLayer.push(arguments);
    };

  function syncGoogleTagState(state) {
    window.gtag('set', {
      traffic_type: state.mode === 'internal' ? 'internal' : 'external',
    });

    if (state.mode === 'debug') {
      // Configure the GA4 destination for DebugView without creating another
      // automatic page_view; native/custom events can then inherit Debug mode.
      window.gtag('config', GA4_MEASUREMENT_ID, {
        debug_mode: true,
        send_page_view: false,
      });
    }
  }

  const initialState = analyticsMode.getState();
  let currentMode = initialState.mode;

  // Queue the initial state before GTM / native Google tags initialize.
  syncGoogleTagState(initialState);

  // Keep Google-wide state synchronized when staff change modes. Entering
  // Debug can happen in-place. Leaving Debug reloads once so the new document
  // starts without any previously enabled GA4 debug context.
  window.addEventListener(analyticsMode.CONFIG.MODE_CHANGE_EVENT, (event) => {
    const nextState = event.detail || analyticsMode.getState();
    const previousMode = currentMode;
    currentMode = nextState.mode;

    if (previousMode === 'debug' && nextState.mode !== 'debug') {
      window.location.reload();
      return;
    }

    syncGoogleTagState(nextState);
  });
})();
